define([
  "underscore",
  "i18n/i18n",
  "utils/url",
  "utils/browser",
  "utils/browser-detect"
  ], function(
    _,
    i18n,
    url,
    browser,
    BrowserDetect
  ) {

  var LOCAL_STORAGE_KEY = 'mb-clientnotifications-storage';
  var PREVIEW_INFO_SCREEN_QUERY_PARAM_NAME = 'previewClientNotificationId';

  var ClientNotification = function() {
    var previewClientNotificationId = url.getQueryParam(window.location.href, PREVIEW_INFO_SCREEN_QUERY_PARAM_NAME);

    var handleHref = function(apiLocation, href) {
      var absoluteRegEx = /^(https?:\/\/)/;
      let backward =  "../..";

      if (!absoluteRegEx.test(href)){
        if (!startsWithChar(href, '/')) {
          backward = backward + "/";
        }

        if (!endsWithChar(apiLocation, "/")) {
          backward = "/" + backward;
        }
        return apiLocation + backward + href;
      }

      return href;
    };

    var startsWithChar = function (str, char) {
      return str.charAt(0) === char;
    };

    var endsWithChar = function (str, char) {
      return str.charAt(str.length -1) === char;
    };

    var setCookie = function(name, value, hours) {
      var expires = "";
      if (hours) {
          var date = new Date();
          date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    };

    var canDisplayClientNotification = function(clientNotificationItem) {
      if (!validateClientNotification(clientNotificationItem)) {
        return false;
      }

      if (previewClientNotificationId === clientNotificationItem.id) {
        return true;
      }

      if (!clientNotificationItem.is_enabled) {
        return false;
      }

      var isAppTarget = targetApplicationCheck(clientNotificationItem);
      if (!isAppTarget) {
        return false;
      }

      if (isClientNotificationItemRead(clientNotificationItem)) {
        return false;
      }

      return true;
    }

    var markClientNotificationAsRead = function (clientNotificationItem) {
      var storedItems = getStoredClientNotifications();

      storedItems[clientNotificationItem.id] = clientNotificationItem;
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storedItems));
    }

    var snoozNotification = function (clientNotificationItem, snoozNotificationInHours) {
      var storedItems = getStoredClientNotifications();

      var hours = 24;

      if (snoozNotificationInHours) {
        hours = snoozNotificationInHours;
      }

      var now = new Date();
      var hoursToAdd = hours * 60 * 60 * 1000;
      var futureTimestamp = now.getTime() + hoursToAdd;


      clientNotificationItem.snoozUntil = futureTimestamp;

      storedItems[clientNotificationItem.id] = clientNotificationItem;
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storedItems));
    }

    var canShowSnoozedNotification = function (notificationItem) {
      var now = new Date();
      if (notificationItem.snoozUntil && now.getTime() >= notificationItem.snoozUntil) {
        return true;
      }

      return false;
    }

    var validateClientNotification = function (clientNotificationItem) {
      if (clientNotificationItem && clientNotificationItem.id) {
        return true;
      }

      console.warn('ClientNotification is not valid', clientNotificationItem);
      return false;
    }

    var getStoredClientNotifications = function() {
      var storage = localStorage.getItem(LOCAL_STORAGE_KEY);
      try {
        var json = JSON.parse(storage);
        return json || {};
      } catch (e) {
        return {};
      }
    }

    var isClientNotificationItemRead = function(clientNotificationItem) {
      var storedItems = getStoredClientNotifications();
      if (!storedItems) {
        return false;
      }

      var foundClientNotification = storedItems[clientNotificationItem.id];
      if (foundClientNotification && foundClientNotification.version === clientNotificationItem.version) {

        var canSnoozedNotificationBeDisplayed = canShowSnoozedNotification(foundClientNotification);

        // If the snnoze time passed, show it again
        if (canSnoozedNotificationBeDisplayed) {
          return false;
        }

        return true;
      }

      return false;
    }

    var targetApplicationCheck = function(clientNotificationItem) {
      if (clientNotificationItem.target_applications && clientNotificationItem.target_applications.length) {
        clientNotificationItem.target_applications = clientNotificationItem.target_applications.map(function(i) {  return i.toLowerCase() })
        var browserName = BrowserDetect.detectCurrentBrowserName();
        var isOutlookEnvironment = browser.isOutlook();
        // This is defined in the notificaiton json file
        if (isOutlookEnvironment) browserName = 'outlook';

        if (browserName && clientNotificationItem.target_applications.includes(browserName.toLowerCase())) {
          return true;
        } else {
          return false;
        }
      }

      return true;
    }

    var getTextForLanguage = function(propertyValue) {
      var appLocale = i18n.locale.toLowerCase();
      var appLang = appLocale.split('-')[0];
      if (Array.isArray(propertyValue)) {
        return getLableObject(propertyValue, appLocale, appLang);
      } else {
        if (propertyValue[appLocale]) {
          return propertyValue[appLocale];
        } else if (propertyValue[appLang]) {
          return propertyValue[appLang];
        } else if (propertyValue['en']) {
          return propertyValue['en'];
        } else {
          return propertyValue[appLang];
        }
      }
    };

    var getLableObject = function (i18nPropertiesArray, appLocale, appLang) {
      var foundLanguageLable = "";
      for (var i = 0; i < i18nPropertiesArray.length; i++) {
        if (
          i18nPropertiesArray[i].key === appLang ||
          i18nPropertiesArray[i].key === appLocale
        ) {
          foundLanguageLable = i18nPropertiesArray[i].value;
          break;
        } else if (i18nPropertiesArray[i].key === 'en') {
          foundLanguageLable = i18nPropertiesArray[i].value;
        }
      }
      return foundLanguageLable;
    };

    return {
      canDisplayClientNotification: canDisplayClientNotification,
      getTextForLanguage: getTextForLanguage,
      markClientNotificationAsRead: markClientNotificationAsRead,
      snoozNotification: snoozNotification,
      handleHref: handleHref,
      setCookie: setCookie
    }
  };

  return ClientNotification();
});
